
import Vue from 'vue';
import { useStore as useNotificationStore } from '@/stores/v2/notification';
import { mapState } from 'pinia';
import ClosedNotifications from './ClosedNotifications.vue';
import OpenNotifications from './OpenNotifications.vue';
import { NotificationResult } from '../../typings/notification';

export default Vue.extend({
  name: 'NotificationsManagement',

  components: {
    ClosedNotifications,
    OpenNotifications,
  },

  props: {
    shouldOpenNotifications: { type: Boolean, required: false, default: false },
  },

  data() {
    return {
      isNotContainerOpen: false,
    };
  },

  computed: {
    ...mapState(useNotificationStore, [
      'redAndOrangeNotifications',
      'hasRedNotifications',
      'getVectorizeNotifications',
    ]),

    allVisibleNotifications(): NotificationResult[] {
      return [
        ...this.redAndOrangeNotifications,
        ...this.getVectorizeNotifications,
      ];
    },

    notificationsNum(): number {
      return this.allVisibleNotifications.length;
    },
  },
  methods: {
    onCloseNotifications() {
      this.isNotContainerOpen = false;
      this.$emit('notifications:closed');
    },
  },
});
